module.exports = __webpack_public_path__ + "static/img/Max_Gawn_mobile.9fae20c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Max_Gawn_mobile.jpg
// module id = 8TeY
// module chunks = 0